<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 3.4375C6.37563 3.4375 3.4375 6.37563 3.4375 10C3.4375 13.6244 6.37563 16.5625 10 16.5625C13.6244 16.5625 16.5625 13.6244 16.5625 10C16.5625 6.37563 13.6244 3.4375 10 3.4375ZM13.75 12.9167L12.9167 13.75L10 10.8333L7.08333 13.75L6.25 12.9167L9.16667 10L6.25 7.08333L7.08333 6.25L10 9.16667L12.9167 6.25L13.75 7.08333L10.8333 10L13.75 12.9167Z"
      fill="currentColor"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IcCheckFalse',
} as DefineComponent
</script>
